export default __webpack_public_path__ + "static/media/humanai.4c5cba0a.png";